export default class PuzzleLayout extends Phaser.GameObjects.Container {
    constructor(scene) {
        super(scene);

        this.gridSize = null;
        this.colCount = null;
        this.rowCount = null;

        this.spotMatrix = null;
    }

    reset(rowCnt, colCnt) {
        this.colCount = colCnt;
        this.rowCount = rowCnt;
        this.spotMatrix = [];
        for (let row = 0; row < this.rowCount; row++) {
            for (let col = 0; col < this.colCount; col++) {
                if (!this.spotMatrix[row]) this.spotMatrix[row] = [];
                this.spotMatrix[row][col] = -1;
            }
        }
    }

    setTileValue (index, value) {
        let col = index % this.colCount;
        let row = Math.floor(index / this.colCount);
        this.spotMatrix[row][col] = value;
    }
}